export default __webpack_public_path__ + "static/media/img1.0ccba9db.avif";